// Mock data for Bits-n-Bytes Infotech

export const shopInfo = {
  name: "Bits-n-Bytes Infotech",
  tagline: "Your Trusted IT Partner Since 2001",
  description: "24+ years of trusted IT support and electronics solutions in Jassur, Himachal Pradesh",
  address: "Backside Kuldeep Enterprises, Sherawali Glass Gali, Jassur, Himachal Pradesh 176201",
  phone: "+91 98160 27655",
  whatsapp: "+919816027655",
  email: "bitsnbytesinfotech@gmail.com",
  openingHours: {
    weekdays: "9:30 AM - 7:00 PM",
    saturday: "9:30 AM - 7:00 PM",
    sunday: "Closed"
  }
};

export const shopLogo = "https://customer-assets.emergentagent.com/job_electrohub-display/artifacts/yflnwn28_Gemini_Generated_Image_iiydp2iiydp2iiyd.png";

export const brands = [
  { id: 1, name: "Canon", logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0a/Canon_wordmark.svg/200px-Canon_wordmark.svg.png" },
  { id: 2, name: "HP", logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ad/HP_logo_2012.svg/150px-HP_logo_2012.svg.png" },
  { id: 3, name: "Altec Lansing", logo: "https://customer-assets.emergentagent.com/job_electrohub-display/artifacts/xlxb6yzw_altec%20lansing.png" },
  { id: 4, name: "Asus", logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2e/ASUS_Logo.svg/200px-ASUS_Logo.svg.png" },
  { id: 5, name: "CP Plus", logo: "https://customer-assets.emergentagent.com/job_electrohub-display/artifacts/vx4rglaw_cp%20plus.png" },
  { id: 6, name: "Zebronics", logo: "https://customer-assets.emergentagent.com/job_electrohub-display/artifacts/m052ivrq_zebronicx-logo-black.webp" }
];

export const productCategories = [
  {
    id: 1,
    title: "Computers & Laptops",
    description: "Desktop computers, laptops, and custom-built systems tailored to your needs",
    image: "https://images.unsplash.com/photo-1571857089849-f6390447191a?w=400",
    items: ["Desktop Computers", "Laptops", "Custom Built PCs", "Workstations", "All-in-One PCs"]
  },
  {
    id: 2,
    title: "Canon Printers",
    description: "Official Canon Pixma Zone - inkjet, laser, and multifunction printers",
    image: "https://images.unsplash.com/photo-1612815154858-60aa4c59eaa6?w=400",
    items: ["Inkjet Printers", "Laser Printers", "Multifunction Printers", "Photo Printers", "Ink Cartridges"]
  },
  {
    id: 3,
    title: "Computer Accessories",
    description: "Keyboards, mice, webcams, USB devices, and essential peripherals",
    image: "https://images.unsplash.com/photo-1577375729078-820d5283031c?w=400",
    items: ["Keyboards", "Mice", "Webcams", "USB Hubs", "Laptop Stands"]
  },
  {
    id: 4,
    title: "Audio & Speakers",
    description: "Altec Lansing and Zebronics speakers, headphones, and audio systems",
    image: "https://images.unsplash.com/photo-1545454675-3531b543be5d?w=400",
    items: ["Bluetooth Speakers", "Soundbars", "Headphones", "Earbuds", "Home Theater"]
  },
  {
    id: 5,
    title: "Security Cameras",
    description: "CP Plus CCTV cameras and security surveillance solutions",
    image: "https://images.unsplash.com/photo-1557597774-9d273605dfa9?w=400",
    items: ["Dome Cameras", "Bullet Cameras", "DVR Systems", "IP Cameras", "Wireless Cameras"]
  },
  {
    id: 6,
    title: "Networking Equipment",
    description: "Routers, switches, cables, and networking solutions for home and office",
    image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=400",
    items: ["WiFi Routers", "Network Switches", "Ethernet Cables", "Range Extenders", "Modems"]
  }
];

export const services = [
  {
    id: 1,
    title: "Computer Repair & Maintenance",
    description: "Expert diagnosis, repair, and maintenance services for all computer brands and models.",
    icon: "Wrench"
  },
  {
    id: 2,
    title: "Hardware & Software Installation",
    description: "Professional installation of components, operating systems, and applications.",
    icon: "HardDrive"
  },
  {
    id: 3,
    title: "Virus & Malware Removal",
    description: "Complete system cleanup and protection from viruses, malware, and security threats.",
    icon: "ShieldCheck"
  },
  {
    id: 4,
    title: "Data Backup & Recovery",
    description: "Secure data backup solutions and professional data recovery from damaged drives.",
    icon: "Database"
  },
  {
    id: 5,
    title: "Network & Printer Setup",
    description: "Home and office networking setup, printer configuration, and troubleshooting.",
    icon: "Wifi"
  },
  {
    id: 6,
    title: "Custom Computer Building",
    description: "Build your dream PC with customized specifications for gaming, work, or creativity.",
    icon: "Cpu"
  },
  {
    id: 7,
    title: "Computer Upgrades",
    description: "RAM upgrades, SSD installations, graphics card upgrades to boost performance.",
    icon: "TrendingUp"
  },
  {
    id: 8,
    title: "Screen Replacement",
    description: "Laptop and monitor screen repair and replacement services.",
    icon: "Monitor"
  },
  {
    id: 9,
    title: "IT Consulting",
    description: "Expert advice on technology solutions for individuals and businesses.",
    icon: "Lightbulb"
  },
  {
    id: 10,
    title: "Windows PC Support",
    description: "Complete Windows troubleshooting, optimization, and support services.",
    icon: "Laptop"
  },
  {
    id: 11,
    title: "Canon Printer Solutions",
    description: "Official Canon Pixma Zone - sales, setup, and support for Canon printers.",
    icon: "Printer"
  },
  {
    id: 12,
    title: "Server Support",
    description: "Server setup, maintenance, and support for small businesses.",
    icon: "Server"
  }
];

export const whyChooseUs = [
  {
    id: 1,
    title: "24+ Years Experience",
    description: "Over two decades of trusted IT expertise serving the Jassur community since 2001.",
    icon: "Award"
  },
  {
    id: 2,
    title: "Genuine Products",
    description: "We only sell authentic products from authorized dealers with full warranty.",
    icon: "BadgeCheck"
  },
  {
    id: 3,
    title: "Expert Support",
    description: "Skilled technicians providing personalized solutions and after-sales support.",
    icon: "Users"
  },
  {
    id: 4,
    title: "Local & Reliable",
    description: "Your neighborhood IT partner - always accessible, always dependable.",
    icon: "MapPin"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Rajesh Sharma",
    role: "Business Owner",
    content: "Bits-n-Bytes has been managing our office computers for years. Their service is prompt and reliable. Highly recommended!",
    rating: 5
  },
  {
    id: 2,
    name: "Priya Thakur",
    role: "Home User",
    content: "Got my laptop repaired here. Excellent service and fair pricing. The staff is very knowledgeable and helpful.",
    rating: 5
  },
  {
    id: 3,
    name: "Amit Verma",
    role: "Student",
    content: "They built a custom PC for me within my budget. Great advice and support. Best IT shop in Jassur!",
    rating: 5
  }
];